import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

import LockIcon from "@mui/icons-material/Lock";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { CRM_LeyendaAuditoria } from "./CRM_LeyendaAuditoria";
import { CRM_LeyendaDepartamento } from "./CRM_LeyendaDepartamento";
import { construirAuditoriaLocal } from "./construirAuditoriaLocal";

// Formulario vacío — usado cuando no hay cliente registrado (aún no hay constancia fiscal)
const FORM_VACIO = {
  cp: "",
  domicilio: "",
  localidad: "",
  municipio: "",
  estado: "",
  correo: "",
  regimenFiscal: "601 - General de Ley Personas Morales",
};

// Convierte info_Facturacion_cliente (Clientes/GetInfoClienteID, mdl_Info_Cliente_Facturacion_CRM) al formulario
const mapFacturacionToForm = (facturacion) => ({
  cp: facturacion?.cp ? String(facturacion.cp) : "",
  domicilio: facturacion?.domicilio || "",
  localidad: facturacion?.localidad || "",
  municipio: facturacion?.municipio || "",
  estado: facturacion?.estado || "",
  correo: facturacion?.correo || "",
  regimenFiscal: FORM_VACIO.regimenFiscal,
});

export const CRM_DetalleFacturacion = ({ esNuevo, idcliente, cliente, facturacionCliente, soloLectura = false, responsableDepartamento = [] }) => {
  const { empleado } = useSelector((store) => store.usuario);
  const valorInicial = esNuevo ? FORM_VACIO : mapFacturacionToForm(facturacionCliente);
  const [editing, setEditing] = useState(esNuevo);
  const [form, setForm] = useState(valorInicial);
  const [auditoria, setAuditoria] = useState(facturacionCliente);

  // facturacionCliente llega después del primer render (fetch async en CRM_DetalleScreen) — se sincroniza aquí
  useEffect(() => {
    if (esNuevo || !facturacionCliente) return;
    setForm(mapFacturacionToForm(facturacionCliente));
    setAuditoria(facturacionCliente);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facturacionCliente]);

  const fieldClass = () => (editing ? "crm-field-editable" : "crm-field-readonly");

  const handleChange = (campo) => (e) => {
    setForm((prev) => ({ ...prev, [campo]: e.target.value }));
  };

  const handleEditar = () => setEditing(true);

  const handleCancelar = () => {
    setForm(valorInicial);
    setEditing(false);
  };

  const handleGuardar = () => {
    if (!form.cp) {
      Swal.fire("CLIENTES", "Favor de escribir el codigo postal del cliente", "warning");
      return;
    }
    if (!form.domicilio) {
      Swal.fire("CLIENTES", "Favor de escribir el domicilio del cliente", "warning");
      return;
    }
    if (!form.localidad) {
      Swal.fire("CLIENTES", "Favor de escribir la localidad del cliente", "warning");
      return;
    }
    if (!form.municipio) {
      Swal.fire("CLIENTES", "Favor de escribir el municipio del cliente", "warning");
      return;
    }
    if (!form.estado) {
      Swal.fire("CLIENTES", "Favor de escribir el estado del cliente", "warning");
      return;
    }
    if (!form.correo) {
      Swal.fire("CLIENTES", "Favor de escribir el correo del cliente", "warning");
      return;
    }

    const body = {
      idcliente: Number(idcliente),
      cp: form.cp,
      domicilio: form.domicilio,
      localidad: form.localidad,
      municipio: form.municipio,
      estado: form.estado,
      correo: form.correo,
    };

    request
      .post("Clientes/GuardarDatosFacturacion", body)
      .then(async () => {
        await Swal.fire("CLIENTES", "Cambios guardados con éxito", "success");
        setAuditoria(construirAuditoriaLocal(empleado));
        setEditing(false);
      })
      .catch((error) => Swal.fire("CLIENTES", JSON.stringify(error), "error"));
  };

  return (
    <div id="sec-facturacion" className="crm-detalle-card" style={{ scrollMarginTop: 170 }}>
      <div className="crm-detalle-card-header crm-detalle-card-header-actions">
        <div>
          <h3>Facturación</h3>
          <p>Datos fiscales para la emisión de comprobantes</p>
        </div>
        <div className="crm-detalle-card-header-buttons">
          {editing ? (
            <>
              <button type="button" className="btn-icono-ghost" title="Cancelar" onClick={handleCancelar}>
                <CloseIcon />
              </button>
              <button type="button" className="btn-icono-solido" title="Guardar cambios" onClick={handleGuardar}>
                <CheckIcon />
                <span>Guardar</span>
              </button>
            </>
          ) : (
            !soloLectura && (
              <button className="btn-icono-ghost btn-editar" title="Editar" onClick={handleEditar}>
                <EditIcon />
                <span>Editar</span>
              </button>
            )
          )}
        </div>
      </div>

      <div className="crm-detalle-card-body">
        <div className="crm-detalle-nota-bloqueo">
          <LockIcon /> {esNuevo ? "Estos datos se completan al cargar la constancia fiscal del cliente" : "Estos datos se obtienen automáticamente y aparecen bloqueados"}
        </div>

        <div className="crm-detalle-grid crm-detalle-grid-4">
          <div className="crm-field">
            <label>Razón social</label>
            <input type="text" className={"crm-field-fx"} value={cliente?.razon_social || ""} placeholder="-" disabled />
          </div>
          <div className="crm-field">
            <label>RFC</label>
            <input type="text" className={"crm-field-fx"} value={cliente?.rfc || ""} placeholder="-" disabled />
          </div>
          <div className="crm-field">
            <label>Código postal</label>
            <input type="text" className={editing === true ? fieldClass() : "crm-field-fx"} value={form.cp} placeholder="-" disabled={editing === false} onChange={handleChange("cp")} />
          </div>
          <div className="crm-field">
            <label>Domicilio facturación</label>
            <input type="text" className={editing === true ? fieldClass() : "crm-field-fx"} value={form.domicilio} placeholder="-" disabled={editing === false} onChange={handleChange("domicilio")} />
          </div>
          <div className="crm-field">
            <label>Localidad</label>
            <input type="text" className={editing === true ? fieldClass() : "crm-field-fx"} value={form.localidad} placeholder="-" disabled={editing === false} onChange={handleChange("localidad")} />
          </div>
          <div className="crm-field">
            <label>Municipio</label>
            <input type="text" className={editing === true ? fieldClass() : "crm-field-fx"} value={form.municipio} placeholder="-" disabled={editing === false} onChange={handleChange("municipio")} />
          </div>
          <div className="crm-field">
            <label>Estado</label>
            <input type="text" className={editing === true ? fieldClass() : "crm-field-fx"} value={form.estado} placeholder="-" disabled={editing === false} onChange={handleChange("estado")} />
          </div>
          <div className="crm-field">
            <label>Correo</label>
            <input type="text" className={editing === true ? fieldClass() : "crm-field-fx"} value={form.correo} placeholder="-" disabled={editing === false} onChange={handleChange("correo")} />
          </div>
        </div>

        <div className="crm-detalle-grid">
          <div className="crm-field">
            <label>Régimen fiscal</label>
            <select className={"crm-field-fx"} disabled value={form.regimenFiscal} >
              <option>601 - General de Ley Personas Morales</option>
              <option>612 - Personas Físicas con Actividades Empresariales</option>
              <option>626 - Régimen Simplificado de Confianza</option>
            </select>
          </div>
        </div>
      </div>

      <div className="crm-detalle-card-footer">
        <CRM_LeyendaDepartamento responsables={responsableDepartamento} idrel={5} />
        <CRM_LeyendaAuditoria auditoria={auditoria} />
      </div>
    </div>
  );
};
